<template>
  <div>
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <p class="lead m-0">Novo lançamento</p>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="w-50 mt-3">
        <form @submit="save" enctype="multipart/form-data">
          <div class="form-group">
            <label>Tipo</label>
            <select
              v-model="machine.machine_type_id"
              class="form-control"
              @change="onMachineTypeSelect($event)"
            >
              <option
                v-for="machine_type in machine_types"
                :key="machine_type.id"
                :value="machine_type.id"
                :data-label="machine_type.label"
              >
                {{ machine_type.name }}
              </option>
            </select>
          </div>

          <template v-if="true || machine.machine_type_id != null">
            <div class="form-group">
              <label>Setor</label>
              <AutoComplete
                v-model="machine.company_sector.name"
                :dropdown="true"
                :suggestions="filtered_company_sectors"
                field="name"
                class="w-100"
                @complete="filterCompanySectors($event)"
                @item-select="onCompanySectorSelect($event)"
              />
            </div>

            <div class="form-group">
              <label>Área</label>
              <AutoComplete
                v-model="machine.company_area.name"
                :dropdown="true"
                :suggestions="filtered_company_areas"
                field="name"
                class="w-100"
                @complete="filterCompanyAreas($event)"
                @item-select="onCompanyAreaSelect($event)"
              />
            </div>

            <div class="form-group">
              <label>Complemento</label>
              <AutoComplete
                v-model="machine.company_complement.name"
                :dropdown="true"
                :suggestions="filtered_company_complements"
                field="name"
                class="w-100"
                @complete="filterCompanyComplements($event)"
                @item-select="onCompanyComplementSelect($event)"
              />
            </div>

            <div class="form-group">
              <label>Tag AMBRA</label>
              <input
                type="text"
                v-model="machine.ambra_tag"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Tag do {{ machine_placeholder }}</label>
              <input
                type="text"
                v-model="machine.machine_tag"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Tag do {{ machine_placeholder }} primário</label>
              <input
                type="text"
                v-model="machine.primary_machine_tag"
                class="form-control"
              />
            </div>

            <div class="form-group" v-if="machine.machine_type_id == 4">
              <div class="form-group">
                <label>Nome do {{ machine_placeholder }}</label>
                <input
                  type="text"
                  v-model="machine.name"
                  class="form-control"
                  aria-describedby="name_help_text"
                />
                <small id="name_help_text" class="form-text text-muted">
                  Campo livre.
                </small>
              </div>
            </div>
            <div class="form-group" v-else>
              <label>Classe do {{ machine_placeholder }}</label>
              <AutoComplete
                v-model="machine.machine_class_id"
                :dropdown="true"
                :suggestions="filtered_company_class"
                field="name"
                class="w-100"
                @complete="filterCompanyClass($event)"
                @item-select="onCompanyClassSelect($event)"
              />
              <!--            <select v-model="machine.machine_class_id" class="form-control">-->
              <!--              <option-->
              <!--                v-for="machine_class in all_machine_classes"-->
              <!--                :key="machine_class.id"-->
              <!--                :value="machine_class.id"-->
              <!--              >-->
              <!--                {{ machine_class.name }}-->
              <!--              </option>-->
              <!--            </select>-->
            </div>

            <div class="form-group">
              <label>Foto do {{ machine_placeholder }}</label>
              <input
                type="file"
                class="form-control-file"
                name="picture"
                @change="onPictureSelect"
              />
            </div>

            <div class="form-group">
              <label>Foto da Tag Ambra</label>
              <input
                type="file"
                class="form-control-file"
                name="ambra_tag_picture"
                @change="onAmbraTagPictureSelect"
              />
            </div>

            <div class="form-group">
              <label>Capacidades</label>
              <AutoComplete
                v-model="machine.capacity"
                :dropdown="true"
                :suggestions="filtered_capacities"
                class="w-100"
                @complete="filterCapacities($event)"
                @item-select="onCapacitySelect($event)"
              />
            </div>

            <div class="form-group">
              <label>Tensão</label>
              <AutoComplete
                v-model="machine.voltage"
                :dropdown="true"
                :suggestions="filtered_voltages"
                class="w-100"
                @complete="filterVoltages($event)"
                @item-select="onVoltageSelect($event)"
              />
            </div>

            <div v-if="showOptionalForm">
                <div class="form-group alert alert-warning">
              <label>Seleionar todos os campos</label>

              <div class="d-flex" style="max-width: 500px">
                <div class="form-check form-check-inline">
                  <input
                          class="form-check-input"
                          type="radio"
                          value="Sim"
                          id="sim"
                          v-model="machine.safety_systems_radio"
                          @click="setValueAllSafetySystems('Sim')"
                  />
                  <label for="sim" class="form-check-label">
                    Sim
                  </label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                          class="form-check-input"
                          type="radio"
                          value="Não"
                          id="nao"
                          v-model="machine.safety_systems_radio"
                          @click="setValueAllSafetySystems('Não')"
                  />
                  <label for="nao" class="form-check-label">
                    Não
                  </label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                          class="form-check-input"
                          type="radio"
                          value="N/A"
                          id="na"
                          v-model="machine.safety_systems_radio"
                          @click="setValueAllSafetySystems('N/A')"
                  />
                  <label for="na" class="form-check-label">
                    N/A
                  </label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                          class="form-check-input"
                          type="radio"
                          value="I/C"
                          id="ic"
                          v-model="machine.safety_systems_radio"
                          @click="setValueAllSafetySystems('I/C')"
                  />
                  <label for="ic" class="form-check-label">
                    I/C
                  </label>
                </div>
              </div>
            </div>
              <div
                class="form-group"
                v-for="(safety_system, index) in safety_systems"
                :key="safety_system.id"
              >
                <label class="form-check-label">
                  {{ safety_system.name }}
                </label>
                <div class="d-flex" style="max-width: 500px">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="'safety_system_radio_sim_' + safety_system.id"
                      value="Sim"
                      v-model="machine.safety_systems[index]"
                      @click="setValueSafetySystems(safety_system.id, 'Sim')"
                    />
                    <label
                      class="form-check-label"
                      :for="'safety_system_radio_sim_' + safety_system.id"
                    >
                      Sim
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="'safety_system_radio_nao_' + safety_system.id"
                      value="Não"
                      v-model="machine.safety_systems[index]"
                      @click="setValueSafetySystems(safety_system.id, 'Não')"
                    />
                    <label
                      class="form-check-label"
                      :for="'safety_system_radio_nao_' + safety_system.id"
                    >
                      Não
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="'safety_system_radio_na_' + safety_system.id"
                      value="N/A"
                      v-model="machine.safety_systems[index]"
                      @click="setValueSafetySystems(safety_system.id, 'N/A')"
                    />
                    <label
                      class="form-check-label"
                      :for="'safety_system_radio_na_' + safety_system.id"
                    >
                      N/A
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="'safety_system_radio_ic_' + safety_system.id"
                      value="I/C"
                      v-model="machine.safety_systems[index]"
                      @click="setValueSafetySystems(safety_system.id, 'I/C')"
                    />
                    <label
                      class="form-check-label"
                      :for="'safety_system_radio_ic_' + safety_system.id"
                    >
                      I/C
                    </label>
                  </div>
                </div>
                <hr />
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="machine.has_ground_wire"
                    :value="1"
                    id="has_ground_wire"
                  />
                  <label class="form-check-label" for="has_ground_wire">
                    Possui aterramento
                  </label>
                </div>
              </div>
            </div>

            <button class="btn btn-dark">{{ submit_text }}</button>
          </template>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'

  import AutoComplete from 'primevue/autocomplete'

  import useCompanyAreas from '@/modules/CompanyArea.js'
  import useCompanyComplements from '@/modules/CompanyComplement.js'
  import useCompanySectors from '@/modules/CompanySector.js'
  import useMachineClasses from '@/modules/MachineClass.js'
  import useMachineTypes from '@/modules/MachineType.js'
  import useSafetySystems from '@/modules/SafetySystem.js'
  import useMachineCapacities from "../../modules/MachineCapacity";
  import useSwal from "../../modules/Swal";
  import Swal from 'sweetalert2/src/sweetalert2.js'

  export default {
    components: {
      AutoComplete,
    },
    setup() {
      const route = useRoute()
      const store = useStore()
      const company = computed(() => store.getters.selected_company)
      const order_of_service = computed(() => store.getters.selected_order_of_service)

      const { company_areas, listCompanyAreasBySector } = useCompanyAreas()
      const { company_complements, listCompanyComplementsByArea } =
        useCompanyComplements()
      const { company_sectors, listCompanySectors } = useCompanySectors()
      const { machine_classes, listMachineClasses } = useMachineClasses()
      const { machine_types, listMachineTypes } = useMachineTypes()
      const { safety_systems, listSafetySystems } = useSafetySystems()
      const { machine_capacities, listMachineCapacities } =
        useMachineCapacities()
      const { showSuccessDialog, showErrorDialog, showAjaxDialog } = useSwal()

      listMachineTypes()
      listMachineClasses()
      listSafetySystems()
      listCompanySectors(company.value?.id)
      listMachineCapacities()

      if (route.name === 'machine-edit' && route.params.id) {
        //
      }

      return {
        company,
        order_of_service,
        company_areas,
        company_complements,
        company_sectors,
        listCompanyAreasBySector,
        listCompanyComplementsByArea,
        machine_classes,
        machine_types,
        safety_systems,
        listMachineClasses,
        machine_capacities,
        listMachineCapacities,
        showErrorDialog,
        showSuccessDialog,
        showAjaxDialog,
      }
    },
    data() {
      return {
        showOptionalForm: false,
        machine: {
          id: null,
          company_id: null,
          order_of_service_id: null,
          machine_type_id: null,
          machine_class_id: null,
          company_sector: {
            name: '',
          },
          company_area: {
            name: '',
          },
          company_complement: {
            name: '',
          },
          name: '',
          ambra_tag: '',
          machine_tag: '',
          primary_machine_tag: 'N/A',
          picture: '',
          ambra_tag_picture: '',
          lat: null,
          lon: null,
          capacity: '',
          voltage: '',
          safety_systems: [],
          has_ground_wire: 0,
        },
        filtered_company_class: [],
        filtered_company_areas: [],
        filtered_company_complements: [],
        filtered_company_sectors: [],
        filtered_voltages: [],
        filtered_capacities: [],
        machine_placeholder: 'equipamento',
        submit_text: '',
        voltages: ['110v', '220v', '380v', '440v'],
        safety_systems_values: [],
        safety_systems_radio: null
      }
    },
    mounted() {
      var app = this
      var id = app.$route.params.id

      if (app.$route.name === 'machine-edit' && id) {
        app.axios
          .get('/api/machines/get/' + id)
          .then(function (response) {
            app.machine = response.data.data

            app.machine.safety_systems = app.machine.safety_systems.map(
              function (safety_system) {
                return safety_system.id
              },
            )
          })
          .catch(function (error) {
            throw new Error(error)
          })
        app.submit_text = 'Salvar alterações'
      } else {
        app.submit_text = 'Cadastrar'
      }
    },
    methods: {
      filterCompanyAreas(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_areas = [...this.company_areas]
          } else {
            this.filtered_company_areas = this.company_areas.filter(
              (company_area) => {
                return company_area.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanyClass(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_class = [...this.machine_classes]
          } else {
            this.filtered_company_class = this.machine_classes.filter(
              (machine_class) => {
                return machine_class.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanyComplements(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_complements = [...this.company_complements]
          } else {
            this.filtered_company_complements = this.company_complements.filter(
              (company_complement) => {
                return company_complement.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanySectors(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_sectors = [...this.company_sectors]
          } else {
            this.filtered_company_sectors = this.company_sectors.filter(
              (company_sector) => {
                return company_sector.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterVoltages(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_voltages = [...this.voltages]
          } else {
            this.filtered_voltages = this.voltages.filter((voltage) => {
              return voltage.toLowerCase().startsWith(event.query.toLowerCase())
            })
          }
        }, 250)
      },

      filterCapacities(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_capacities = [...this.machine_capacities]
          } else {
            this.filtered_capacities = this.machine_capacities.filter(
              (machine_capacity) => {
                return machine_capacity
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
          this.filtered_capacities = [
            ...this.filtered_capacities,
            ...['SOB DEMANDA'],
            ...['NAO SOUBE INFORMAR'],
          ]
        }, 250)
      },

      onMachineTypeSelect(event) {
        let selectedItem =
          event.target[event.target.selectedIndex].dataset.label
        this.showOptionalForm = selectedItem === 'equipamento';
      },

      onCompanyAreaSelect(event) {
        this.machine.company_area.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listCompanyComplementsByArea(event.value.id)
      },

      onCompanyClassSelect(event) {
        this.machine.machine_class_id.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listMachineClasses(event.value.id)
      },

      onCompanyComplementSelect(event) {
        this.machine.company_complement.name =
          event.value.name.toLocaleUpperCase('pt-BR')
      },

      onCompanySectorSelect(event) {
        this.machine.company_sector.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listCompanyAreasBySector(event.value.id)
      },

      onVoltageSelect(event) {
        this.machine.voltage = event.value.toLocaleUpperCase('pt-BR')
      },

      onCapacitySelect(event) {
        this.machine.capacity = event.value.toLocaleUpperCase('pt-BR')
      },

      onAmbraTagPictureSelect(event) {
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.addEventListener('load', () => {
          const image = new Image()
          image.src = reader.result
          this.machine.ambra_tag_picture = image
        })

        reader.readAsDataURL(file)
      },

      onPictureSelect(event) {
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.addEventListener('load', () => {
          const image = new Image()
          image.src = reader.result
          this.machine.picture = image
        })

        reader.readAsDataURL(file)
        this.captureFallbackLocation()
      },

      // Localização do navegador no momento do envio da foto do equipamento.
      // O backend só usa isso quando a foto não tem GPS no próprio EXIF —
      // comum em ambientes fechados (fábricas, galpões), onde o GPS da
      // câmera não consegue um fix de satélite a tempo da foto.
      captureFallbackLocation() {
        if (!navigator.geolocation) return

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.machine.lat = position.coords.latitude
            this.machine.lon = position.coords.longitude
          },
          () => {
            // Sem permissão ou sem sinal: segue sem coordenada de fallback,
            // o EXIF da foto (se tiver) continua sendo usado normalmente.
          },
        )
      },

      save: function (event) {
        event.preventDefault()
        let app = this
        let request = {
          url: '/api/machines/storeOrUpdate',
          data: new FormData(),
          config: {
            headers: {
              'content-type': 'multipart/form-data',
            },
          },
        }

        request.data.append('company_id', this.company.id)
        request.data.append('order_of_service_id', this.order_of_service.id)
        request.data.append('id', app.machine.id)
        request.data.append('machine_type_id', app.machine.machine_type_id)
        request.data.append(
          'machine_class_id',
          JSON.stringify(app.machine.machine_class_id),
        )
        request.data.append(
          'company_sector[name]',
          app.machine.company_sector.name,
        )
        request.data.append('company_area[name]', app.machine.company_area.name)
        request.data.append(
          'company_complement[name]',
          app.machine.company_complement.name,
        )
        request.data.append('name', app.machine.name)
        request.data.append('ambra_tag', app.machine.ambra_tag)
        request.data.append('machine_tag', app.machine.machine_tag)
        request.data.append(
          'primary_machine_tag',
          app.machine.primary_machine_tag,
        )
        request.data.append('capacity', app.machine.capacity)
        request.data.append('voltage', app.machine.voltage)
        request.data.append(
          'safety_systems',
          JSON.stringify(this.safety_systems_values),
        )
        request.data.append('has_ground_wire', app.machine.has_ground_wire)

        if (app.machine.lat != null && app.machine.lon != null) {
          request.data.append('lat', app.machine.lat)
          request.data.append('lon', app.machine.lon)
        }

        if (!app.machine.id && !(app.machine.picture instanceof HTMLImageElement && app.machine.ambra_tag_picture instanceof HTMLImageElement)) {
          Swal.fire({ icon: 'warning', title: 'Fotos obrigatórias', text: 'Anexe a foto do equipamento e a foto da Tag Ambra antes de cadastrar.' })
          return
        }

        let blob = this.resizeImage(app.machine.ambra_tag_picture)
        let file = new File([blob], 'default.jpg', { type: blob.type })
        request.data.append('ambra_tag_picture', file)

        blob = this.resizeImage(app.machine.picture)
        file = new File([blob], 'default.jpg', { type: blob.type })
        request.data.append('picture', file)

        Swal.fire({
          title: 'Tem certeza desta operação?',
          text: 'Verifique todos os campos antes de efetuar o cadastro.',
          confirmButtonText: 'Cadastrar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return app.axios
              .post(request.url, request.data, request.config)
              .then(function () {
                app.showSuccessDialog()

                setTimeout(() => {
                  app.$router.push({ path: '/machines' })
                }, 1000)
              })
              .catch((error) => {
            let result = ''

            if (error && error.response.data) {
              let container = document.createElement('div')

              let paragraph = document.createElement('p')
              if (error.response.data.message) {
                paragraph.appendChild(
                  document.createTextNode(error.response.data.message),
                )
                paragraph.classList.add('alert')
                paragraph.classList.add('alert-danger')
              }

              let list = document.createElement('ul')
              for (let key in error.response.data.errors) {
                let itemElement = document.createElement('li')
                itemElement.appendChild(
                  document.createTextNode(error.response.data.errors[key]),
                )
                list.appendChild(itemElement)
              }

              container.appendChild(paragraph)
              container.appendChild(list)
              result = container
            }

            app.showErrorDialog(result)
          })
          }
        })
      },

      setValueSafetySystems: function (id, value) {
        let permission = true

        this.safety_systems_values.map((item, index) => {
          if (item.id === id) {
            this.safety_systems_values[index] = { id, value }
            permission = false
          }
        })

        if (permission) {
          this.safety_systems_values.push({ id, value })
        }
      },
      setValueAllSafetySystems: function(value) {
          this.safety_systems.map((item, index) => {
              this.setValueSafetySystems(item.id, value)
              this.machine.safety_systems[index] = value;
          })
      },
      resizeImage(image) {
        const MAX_WIDTH = 800
        const MAX_HEIGHT = 600

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        let width = image.width
        let height = image.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height
        context.drawImage(image, 0, 0, width, height)
        const b64 = canvas.toDataURL('image/jpeg', 0.8)
        const blob = this.b64toBlob(b64)
        return blob
      },
      b64toBlob(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(arrayBuffer);
        
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([arrayBuffer], { type: 'image/jpeg' });
      },
    },
  }
</script>
